import { useQuery } from '@tanstack/react-query';

import { Importer } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useImporter = (id: string) =>
  useQuery({
    queryKey: ['importer', id],
    queryFn: async (): Promise<Importer> => {
      try {
        const result = await apiClient.importer.retrieveImporterDetails.query({ params: { id } });
        if (result.status !== 200) throw result.body;

        return result.body.importer as Importer;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch importer details');
      }
    },
    enabled: !!id,
  });
